import React from 'react';
import { graphql } from 'gatsby';
import  SpecialLayoutPage  from '../components/layouts/SpecialLayoutPage';

const LayoutPage = ({data}) => {
  return (
    <SpecialLayoutPage
      data={data}
      paddingBottom="1rem"
    />
  )
}
export default LayoutPage

export const pageQuery = graphql`
  query LayoutPageTemplateByID($id: String!, $langKey: String!) {
    page: markdownRemark(
      fields: { langKey: { eq: $langKey } }
      frontmatter: { templateKey: { eq: "special-layout-page" } }, id: { eq: $id }
    ) {
      fields {
        langKey
        slug
        pathSlug
      }
      frontmatter {
        title
        contents {
          isFullWidth
          columnCount
          columns {
            columnOne {
              chunk {
                align
                type
                hasButton
                buttonLabel
                value
                image {
                  childImageSharp {
                    fluid(maxWidth:2048) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                width
                height
                alt
                useMap {
                  mapName
                  area {
                    shape
                    coords
                    alt
                    link
                  }
                }
                title
                marginTop
                marginLeft
                marginRight
                marginBottom
                borderStyle
                isList
                isStriped
                header {
                  cell
                }
                rows {
                  row {
                    cell
                    color
                    textColor
                    colSpan
                  }
                }
                note
                entries {
                  title
                  content
                }
                link
                fieldGroups {
                  groupTitle
                  groupTitleSize
                  groupTitleAlign
                  fieldRows {
                    fields {
                      type
                      name
                      label
                      labelPosition
                      placeholder
                      hasIcon
                      icon
                      options {
                        code
                        label
                      }
                      isRequired
                      isRequiredFormat
                      isReadOnly
                      isDisabled
                      value
                    }
                  }
                }
                formType
                submitText
                hasRecaptcha
                hasCopyToClipboard
                hasDecode
                text
                button {
                  align
                  link
                  value
                }
                size
                paddingBottom
                paddingTop
                margin
                marginLeft
                marginTop
                marginRight
                marginBottom
                overlay {
                  backgroundColor
                  opacity
                }
                images {
                  image {
                    childImageSharp {
                      fluid(maxWidth:2048) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  title
                  text
                }
                titles {
                  sizeMobile
                  sizeTablet
                  sizeWidescreen
                  value
                }
                buttons{
                  link
                  value
                }
                isHome
                isTags
                defLatitude
                defLongitude
                defZoom
                latitude
                longitude
                label
              }
            }
            columnTwo {
              chunk {
                align
                type
                hasButton
                buttonLabel
                value
                image {
                  childImageSharp {
                    fluid(maxWidth:2048) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                width
                height
                alt
                useMap {
                  mapName
                  area {
                    shape
                    coords
                    alt
                    link
                  }
                }
                title
                marginTop
                marginLeft
                marginRight
                marginBottom
                borderStyle
                isList
                isStriped
                header {
                  cell
                }
                rows {
                  row {
                    cell
                    color
                    textColor
                    colSpan
                  }
                }
                note
                entries {
                  title
                  content
                }
                link
                fieldGroups {
                  groupTitle
                  groupTitleSize
                  groupTitleAlign
                  fieldRows {
                    fields {
                      type
                      name
                      label
                      labelPosition
                      placeholder
                      hasIcon
                      icon
                      options {
                        code
                        label
                      }
                      isRequired
                      isRequiredFormat
                      isReadOnly
                      isDisabled
                      value
                    }
                  }
                }
                formType
                submitText
                hasRecaptcha
                hasCopyToClipboard
                hasDecode
                text
                button {
                  align
                  link
                  value
                }
                size
                paddingBottom
                paddingTop
                margin
                marginLeft
                marginTop
                marginRight
                marginBottom
                overlay {
                  backgroundColor
                  opacity
                }
                images {
                  image {
                    childImageSharp {
                      fluid(maxWidth:2048) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  title
                  text
                }
                titles {
                  sizeMobile
                  sizeTablet
                  sizeWidescreen
                  value
                }
                buttons{
                  link
                  value
                }
                isHome
                isTags
                defLatitude
                defLongitude
                defZoom
                latitude
                longitude
                label
              }
            }
            columnThree {
              chunk {
                align
                type
                hasButton
                buttonLabel
                value
                image {
                  childImageSharp {
                    fluid(maxWidth:2048) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                width
                height
                alt
                useMap {
                  mapName
                  area {
                    shape
                    coords
                    alt
                    link
                  }
                }
                title
                marginTop
                marginLeft
                marginRight
                marginBottom
                borderStyle
                isList
                isStriped
                header {
                  cell
                }
                rows {
                  row {
                    cell
                    color
                    textColor
                    colSpan
                  }
                }
                note
                entries {
                  title
                  content
                }
                link
                fieldGroups {
                  groupTitle
                  groupTitleSize
                  groupTitleAlign
                  fieldRows {
                    fields {
                      type
                      name
                      label
                      labelPosition
                      placeholder
                      hasIcon
                      icon
                      options {
                        code
                        label
                      }
                      isRequired
                      isRequiredFormat
                      isReadOnly
                      isDisabled
                      value
                    }
                  }
                }
                formType
                submitText
                hasRecaptcha
                hasCopyToClipboard
                hasDecode
                text
                button {
                  align
                  link
                  value
                }
                size
                paddingBottom
                paddingTop
                margin
                marginLeft
                marginTop
                marginRight
                marginBottom
                overlay {
                  backgroundColor
                  opacity
                }
                images {
                  image {
                    childImageSharp {
                      fluid(maxWidth:2048) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  title
                  text
                }
                titles {
                  sizeMobile
                  sizeTablet
                  sizeWidescreen
                  value
                }
                buttons{
                  link
                  value
                }
                isHome
                isTags
                defLatitude
                defLongitude
                defZoom
                latitude
                longitude
                label
              }
            }
          }
        }
      }
    }
    reusable: allMdx(
      filter: {frontmatter: { key: { eq: "reusable" }, langKey: { eq: $langKey } }}
    ) {
      edges {
        node {
          body
          frontmatter {
            title
          }
        }
      }
    }
  }
`
